import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import CallToAction from "./CallToAction";
import MediaFile from "./MediaFile";
import CreateElement from "./CreateElement";
import WebsiteInput from "./WebsiteView/WebsiteInput";
import DocumentFile from "./DocumentFile";
// import WhiteBoard from "./WhiteBoard";
import {
  deleteElement,
  renameElement,
  updateFolderOrder,
} from "../../../../../services/elementServices";
import { useMeetingContext } from "../../../../../context/MeetingContext";
import { useEditCtaContext } from "../../../../../context/EditCtaContext";
export default function WidgetPanel() {
  const navigate = useNavigate();
  const {
    createFolder,
    step,
    setStep,
    selectedCreateElement,
    setSelectedCreateElement,
    getFolders,
    updatePresetId,
  } = useMeetingContext();

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState("");
  const [showRenameModal, setShowRenameModal] = useState(false);
  const [renameItemId, setRenameItemId] = useState("");
  const [newName, setNewName] = useState("");
  const [updatedFolders] = useState([]);
  // Track which folders are open (fold/unfold)

  const [showAddModal, setShowAddModal] = useState(false);
  const [newFolderName, setNewFolderName] = useState("");
  const [showMenu, setShowMenu] = useState(false);

  const {
    selectedTemplateKey,
    setSelectedTemplateKey,
    setCurrentStep,
    setFormSteps,
  } = useEditCtaContext();

  // Ref for the menu
  const menuRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    setSelectedCreateElement("");
    setSelectedTemplateKey("");
    setCurrentStep("");
    setFormSteps([]);
    setStep("create_element");
  }, [
    setCurrentStep,
    setFormSteps,
    setSelectedCreateElement,
    setSelectedTemplateKey,
    setStep,
  ]);

  useEffect(() => {
    getFolders();
  }, [getFolders]);

  useEffect(() => {
    if (!showMenu) return;
    function handleClickOutside(event) {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setShowMenu(false);
      }
    }
    window.addEventListener("mousedown", handleClickOutside);
    return () => {
      window.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showMenu]);

  const handleDelete = () => {
    if (deleteItemId) {
      deleteElement(deleteItemId);
      getFolders();
      setShowDeleteModal(false);
      setDeleteItemId("");
      setStep("folders");
      setSelectedCreateElement("");
    }
  };

  const handleRename = () => {
    if (renameItemId) {
      renameElement(renameItemId, newName);
      getFolders();
      setShowRenameModal(false);
      setRenameItemId("");
      setNewName("");
    }
  };

  const handleBackToFolders = () => {
    setSelectedCreateElement("");
    navigate(`/dashboard/folders`, { replace: true });
  };

  useEffect(() => {
    if (updatedFolders && updatedFolders.length > 0) {
      try {
        updateFolderOrder(updatedFolders);
      } catch (error) {
        console.log(error);
      }
    }
  }, [updatedFolders]);

  return (
    <div
      className={`w-full  primary-card-background rounded-2xl mt-10 md:mt-0`}
      style={{ pointerEvents: "auto" }}
    >
      {showDeleteModal && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-lg p-6 w-96">
            <h3 className="text-xl font-bold text-gray-800 mb-4">
              Delete Element
            </h3>
            <p className="text-gray-600 mb-6">
              Are you sure you want to delete this element? This action cannot
              be undone.
            </p>
            <div className="flex justify-end gap-2">
              <button
                onClick={() => setShowDeleteModal(false)}
                className="px-4 py-2 text-gray-600 hover:text-gray-800"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  handleDelete();
                  setShowDeleteModal(false);
                }}
                className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {showRenameModal && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-lg p-6 w-96">
            <h3 className="text-xl font-bold text-gray-800 mb-4">
              Rename Element
            </h3>
            <div className="mb-4">
              <label className="block text-gray-700 font-medium mb-2">
                New Name:
              </label>
              <input
                type="text"
                value={newName}
                onChange={(e) => setNewName(e.target.value)}
                placeholder="Enter new name"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <div className="flex justify-end gap-2">
              <button
                onClick={() => setShowRenameModal(false)}
                className="px-4 py-2 text-gray-600 hover:text-gray-800"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  handleRename();
                  setShowRenameModal(false);
                }}
                className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700"
              >
                Rename
              </button>
            </div>
          </div>
        </div>
      )}
      <>
        {/* Back Button - Show when not in folders view */}
        {/* {step !== "folders" && (
          <div className="p-4 border-b border-gray-600">
            <button
              onClick={handleBackToFolders}
              className="flex items-center gap-2 text-white hover:text-gray-300 transition-colors cursor-pointer"
            >
              <FaArrowLeft className="w-4 h-4" />
              <span>Back to Folders</span>
            </button>
          </div>
        )} */}

        {/* Always render CreateElement for the /elemets/:folderId route */}
        <CreateElement />
        {/* CallToAction UI */}

        {/* Add Folder Modal */}
        {showAddModal && (
          <div className="fixed inset-0 z-60 flex items-center justify-center bg-black/50 bg-opacity-40">
            <div className="bg-white rounded-xl shadow-xl p-8 w-full max-w-md mx-4">
              <div className="font-bold text-lg mb-4 text-black">
                Add New Folder
              </div>
              <div className="mb-2 text-sm font-semibold text-black">
                Name:<span className="text-red-600">*</span>{" "}
                <span className="ml-1 text-xs font-normal text-gray-600">
                  0/25
                </span>{" "}
                <span className="inline-block align-middle">
                  <svg
                    className="inline ml-1"
                    width="16"
                    height="16"
                    fill="currentColor"
                    viewBox="0 0 16 16"
                  >
                    <circle cx="8" cy="8" r="8" fill="#888" />
                    <text
                      x="8"
                      y="12"
                      textAnchor="middle"
                      fontSize="10"
                      fill="#fff"
                    >
                      ?
                    </text>
                  </svg>
                </span>
              </div>
              <input
                className="w-full border border-gray-300 rounded px-3 py-2 mb-6 focus:outline-none focus:ring-2 focus:ring-green-500 text-black"
                maxLength={25}
                placeholder="Enter here..."
                value={newFolderName}
                onChange={(e) => setNewFolderName(e.target.value)}
              />
              <div className="flex justify-between">
                <button
                  className="bg-gray-600 text-white px-6 py-2 rounded font-semibold mr-2 hover:bg-gray-700"
                  onClick={() => {
                    setShowAddModal(false);

                    setNewFolderName("");
                  }}
                >
                  Cancel
                </button>
                <button
                  className="bg-green-600 text-white px-6 py-2 rounded font-semibold hover:bg-green-700"
                  onClick={() => {
                    createFolder(newFolderName);
                    setShowAddModal(false);
                    setNewFolderName("");
                  }}
                >
                  Create
                </button>
              </div>
            </div>
          </div>
        )}
      </>
      {/* {selectedCreateElement === "cta" && <CallToAction />}
      {selectedCreateElement === "media_file" && <MediaFile />}
      {selectedCreateElement === "website" && <WebsiteInput />}
      {selectedCreateElement === "document_file" && <DocumentFile />} */}
      {/* {step != "folders" && selectedCreateElement === "whiteboard" && <WhiteBoard />} */}
    </div>
  );
}
